import { useEffect } from 'react'
import { every, isEmpty } from 'lodash'

import { refreshAd } from '../advertisement'

import { Program } from '../types/models'
import { ProgramDetailFragment, CategoryItemFragment, Maybe } from '../types/generated'

type Dependency = Maybe<string | CategoryItemFragment | Program | ProgramDetailFragment>

export default function useRefreshAd(dependencies: Dependency[]) {
  useEffect(() => {
    if (every(dependencies, dependency => !isEmpty(dependency))) {
      refreshAd()
    }
    // eslint-disable-next-line
  }, dependencies)
}
